import { easeInOut } from "./easing"

export function scrollIntoView(container, selected) {
  if (!selected) {
    container.scrollTop = 0
    return
  }

  const top = selected.offsetTop
  const bottom = top + selected.offsetHeight
  const scrollTop = container.scrollTop
  const toBottom = scrollTop + container.clientHeight

  if (top < scrollTop) {
    container.scrollTop = top
  } else if (bottom > toBottom) {
    container.scrollTop = bottom - container.clientHeight
  }
}

export function setScrollTop(el, value) {
  const targetNode = el
  if (targetNode === window) {
    document.body.scrollTop = value
    document.documentElement.scrollTop = value
  } else {
    targetNode.scrollTop = value
  }
}

export function scrollTop(el, from = 0, to, duration = 500) {
  if (duration <= 10) {
    setScrollTop(el, to)
    return
  }

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame =
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function(callback) {
        return window.setTimeout(callback, 1000 / 60)
      }
  }

  const step = Math.ceil(duration / 10)

  let currentStep = 0
  let currentTop = from
  let run = () => {
    currentTop = easeInOut(currentStep++, currentTop, to - currentTop, step)
    setScrollTop(el, currentTop)

    if (currentTop !== to) {
      window.requestAnimationFrame(run)
    } else {
      setScrollTop(el, currentTop)
    }
  }

  window.requestAnimationFrame(run)
}
